module.exports = __webpack_public_path__ + "static/media/Fac1.82b924e0.jpg";